<script>
  import { _ } from 'svelte-i18n';
  import Button from '../elements/Button.svelte'
  import { client_path, modals, storefront_url_to_open, can_upgrade_from_pro_to_business, business_subscription_deactivated } from '../stores'
  import StorefrontSavePendingChanges from './StorefrontSavePendingChanges.svelte';
  export let selectedStorefront
  export let storefront_fonts = []
  let hasPendingChanges = false;
  // Reactive declaration for storefront_url with null check
  
  $: storefront_url = $selectedStorefront 
    ? $client_path + "storefront/" + $selectedStorefront.url_hash 
    : '';

  let justCopied = false;
  function copyStorefrontUrl() {
    navigator.clipboard.writeText(storefront_url);
    justCopied = true;
    setTimeout(() => {
      justCopied = false;
      if ($can_upgrade_from_pro_to_business) {
        modals.open('storefront_watermark_info');
      }
    }, 2000);
  }

  const handlePendingChangesState = (pendingChanges) => {
    console.log('StorefrontURLBar - pending changes:', pendingChanges);
    hasPendingChanges = pendingChanges.detail;
  }

  const handleOpenStorefront = () => {
    if ($can_upgrade_from_pro_to_business) {
      $storefront_url_to_open = storefront_url;
      modals.open('storefront_watermark_info');
    } else {
      window.open(storefront_url, '_blank');
    }
  }
</script>

<div class="StorefrontURLBar">
  <span class="field">
    <span class="label">{$_('modals.editStorefront.url')}</span>
    <a class="url" href="{storefront_url}" target="_blank">{storefront_url}</a>
    <Button kind="outline" size="tiny" on:click={copyStorefrontUrl}>
      {#if justCopied}
        👍 Address copied!
      {:else}
        Copy address{/if}
    </Button>
  </span>
  <div class="button-wrapper">
    <Button kind="outline" disabled={hasPendingChanges} on_warning={hasPendingChanges} on:click={handleOpenStorefront}>
      <span slot="textIcon">↗︎</span>Open customer view
    </Button>
  </div>
  <StorefrontSavePendingChanges {selectedStorefront} {storefront_fonts} on:pendingChanges={handlePendingChangesState}/>
</div>

<style>
  .StorefrontURLBar {
    z-index: 2;
    display: flex;
    flex-direction: row;
    margin: 0 -1rem;
    padding: 1rem 2rem;
    width: calc(100% + 2rem);
    gap: 2rem;
    background-color: var(--c-text-faded-big);
  }
  .label {
    font-size: 1.2rem;
    font-family: var(--PensumSans-Bold);
    font-weight: normal;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--c-text-faded);
  }
  .field {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    gap: 1rem;
    padding: 1rem 2rem;
    background-color: var(--c-nav-bg);
    border-radius: 2rem;
  }
  .url {
    font-size: 1.6rem;
    text-decoration: none;
  }
  .url:hover {
    color: var(--c-accent);
  }

  .button-wrapper {
    z-index: 2;
  }
</style>